/**
 * Filter the FAQs by category.
 */
function filter_faqs() {
  const tabs = document.querySelectorAll(".filters__filter, .topics__item"),
    tabFaqs = document.querySelectorAll(
      ".accordion__item--faqs-noborder, .accordion__item--faqs"
    ),
    showAll = document.querySelector(".show-all");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      let category_filter = tab.dataset.category;

      tabFaqs.forEach((tf) => {
        let category_faq = tf.dataset.category;
        if (category_faq == category_filter) {
          tf.style.display = "block";
        } else {
          tf.style.display = "none";
        }
      });

      tabs.forEach((t) => {
        t.classList.remove("is-active");
      });
      tab.classList.add("is-active");
    });
  });

  /* Redirect to faqs page or show all faqs (and quit filter)*/
  if (showAll != null) {
    showAll.addEventListener("click", () => {
      if (showAll.classList.contains("redirect-all") && showAll.dataset.redirectUrl) {
        location.href = showAll.dataset.redirectUrl;
      } else {
        tabFaqs.forEach((tf) => {
          tf.style.display = "block";
        });
        tabs.forEach((t) => {
          t.classList.remove("is-active");
        });
      }
    });
  }
}

filter_faqs();

export default filter_faqs;
